
function setInput(setState, event) {
  setState(event.target.value)
}

export default setInput